import { z } from 'zod'

const envSchema = z.object({
  REACT_APP_API_URL: z.string().url(),
  REACT_APP_PUSHER_APP_KEY: z.string().optional(),
  REACT_APP_PUSHER_APP_CLUSTER: z.string().optional(),
})

const raw = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? 'http://localhost:8000/api/v1',
  REACT_APP_PUSHER_APP_KEY: process.env.REACT_APP_PUSHER_APP_KEY,
  REACT_APP_PUSHER_APP_CLUSTER: process.env.REACT_APP_PUSHER_APP_CLUSTER,
}

export const env = envSchema.parse(raw)

export const AUTH_TOKEN_KEY = 'hrs_access_token'
